function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "7",
  cy: "7",
  r: "6.25",
  stroke: "#000",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.75 7.25h4.5",
  stroke: "#000",
  strokeWidth: "1.5",
  strokeLinecap: "round"
})));